import React,{useEffect,useState} from 'react'
import { fetchTopSellingProducts } from '../api';
import ProductGrid from '../../products/components/ProductGrid'
import ProductGridSkeleton from '../../products/components/ProductGridSkeleton'
import HomeSection from './HomeSection'
const TrendingProducts = () => {
const [products, setProducts] = useState([]);
const [loading, setLoading] = useState(true);
useEffect(() => {
  setLoading(true);
    const fetchProducts = async () => {
        try {
          const data = await fetchTopSellingProducts();
          setProducts((prevProducts) => {
            const updatedProducts = [...prevProducts, ...data.content];
            return Array.from(
              new Map(updatedProducts.map((p) => [p.id, p])).values()
            );
          }); // Append new products
        } catch (error) {
          console.error("Error searching products:", error);
        } finally {
          setLoading(false);
        }
      };
        fetchProducts();
}, [])

if (!loading && products.length === 0) return null;
    return (
        <HomeSection
          className="trending-products"
          title="Trending"
          subtitle="Popular right now"
          action={{ label: "Shop all products", to: "/products" }}
        >
          {loading ? (
            <ProductGridSkeleton count={6} bare variant="row" />
          ) : (
            <ProductGrid products={products} showLoadmore={false} bare variant="row" />
          )}
        </HomeSection>
    )
}

export default TrendingProducts
